export const inputLabels = {
  badCompanyCode: "Blogas įmonės kodas"
};

export const descriptions = {
  main: `Greitai sužinokite, ar dėl jūsų įmonės vykdomos veiklos reikia
  nustatyti sanitarinės apsaugos zoną. Pasinaudokite mūsų sukurtu
  įrankiu. Įveskite įmonės kodą ir paspauskite mygtuką sužinoti.`,
  notFound:
    "Aplinkos ministerijos turimais duomenimis SAZ nenustatoma. Jeigu pradėjote vykdyti naują ūkinę veiklą ar padidinote vykdomos ūkinės veiklos apimtis, pasitikrinti, ar dėl šios veiklos neprivaloma nustatyti SAZ, galite"
};

export const tableLabels = {
  area: "SAZ dydis, m",
  selectPerformance: "Pasirinkite įrenginių našumą per parą, tūkst. m3",
  companyCode: "Įmonės kodas:",
  companyName: "Įmonės pavadinimas:"
};

export const buttonLabels = {
  findOut: "Sužinoti"
};

export const titles = {
  sanitaryProtection: "Sanitarinės apsaugos",
  area: "zona"
};
